var _mask, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoDisclosure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 14,
    maskUnits: "userSpaceOnUse",
    width: 8,
    x: 4,
    y: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5.27521 1.33333c-.24712 0-.46822.15017-.56045.37837-.0934.2282-.03783.4895.13834.66095l5.6258 5.62577-5.6258 5.62578c-.15844.1513-.22229.3772-.16671.59.05557.2116.2211.3772.43275.4327.21283.0556.43866-.0082.59001-.1667l6.05375-6.05376c.2365-.23648.2365-.61957 0-.85604l-6.05375-6.0538c-.1147-.11705-.27077-.18327-.43394-.18327z",
    fill: "#fff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.27521 1.33333c-.24712 0-.46822.15017-.56045.37837-.0934.2282-.03783.4895.13834.66095l5.6258 5.62577-5.6258 5.62578c-.15844.1513-.22229.3772-.16671.59.05557.2116.2211.3772.43275.4327.21283.0556.43866-.0082.59001-.1667l6.05375-6.05376c.2365-.23648.2365-.61957 0-.85604l-6.05375-6.0538c-.1147-.11705-.27077-.18327-.43394-.18327z",
    fill: "#5d6677"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h16v16h-16z",
    fill: "#c7c7cc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDisclosure);
export default __webpack_public_path__ + "static/media/ico_disclosure.8d816a83b0f4e6a6363e19f03398e7e3.svg";
export { ForwardRef as ReactComponent };